/* eslint-disable @typescript-eslint/no-explicit-any */
import { _Node, TableNode, tableStore } from '../../../stores/table-store';

const applyStoredMapSorting = (
  obj: any,
  map: Record<string, string[]>,
  path: string[] = []
): any => {
  const mapKey = path.length ? `$~${path.join('~')}` : '$';
  const order = map?.[mapKey];

  if (Array.isArray(obj)) {
    return obj.map((item, index) =>
      applyStoredMapSorting(item, map, [...path, index.toString()])
    );
  } else if (obj && typeof obj === 'object') {
    const orderedEntries: [string, any][] = [];

    if (order && Array.isArray(order)) {
      for (const key of order) {
        if (key in obj) {
          orderedEntries.push([
            key,
            applyStoredMapSorting(obj[key], map, [...path, key]),
          ]);
        }
      }
    }

    for (const key of Object.keys(obj)) {
      if (!order || !order.includes(key)) {
        orderedEntries.push([
          key,
          applyStoredMapSorting(obj[key], map, [...path, key]),
        ]);
      }
    }

    return Object.fromEntries(orderedEntries);
  }

  return obj;
};

export const getOrderedJson = <T extends boolean>({
  value,
  rowId,
  columnId,
  stringify = true as T,
}: {
  value: object | string;
  rowId: string;
  columnId: keyof _Node;
  stringify: T;
}): T extends true ? string : object => {
  const columnMapId = `${columnId}Map` as keyof _Node;
  const storedMap = tableStore.getValue(rowId, columnMapId as keyof TableNode);
  let result: any = value;

  try {
    const parsedValue = typeof value === 'string' ? JSON.parse(value) : value;

    result = applyStoredMapSorting(parsedValue, storedMap);
  } catch (error) {
    console.error(`Failed to apply ordered map for ${columnId}`, error);
  }

  const returnValue = (
    stringify ? JSON.stringify(result, null, 2) : result
  ) as T extends true ? string : object;

  return returnValue;
};
